import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'inc-patient-status',
  templateUrl: './patient-status.component.html',
  styleUrls: ['./patient-status.component.scss'],
})
export class PatientStatusComponent {
  @Input() inList: { value: string, label: string }[];
  @Output() callSearch = new EventEmitter<string>();

  constructor() { }

  search(data: any) {
    if (data && data.detail) {
      this.callSearch.emit(data.detail.value);
    }
  }

}
